import React from "react";
import InputFieldV2 from '@/components/InputComponentsV2/InputFieldV2';
import InputWithOTPV2 from '@/components/InputComponentsV2/InputFieldWithOTPV2';

const resolve = (value, ctx) =>
  typeof value === "function" ? value(ctx) : value;

// eslint-disable-next-line react/display-name
const AddressField = React.memo(({
                                   field,
                                   value,
                                   onChange,
                                   error,
                                   context
                                 }) => {
  // visibleIf
  if (field.visibleIf && !field.visibleIf(context)) return null;

  const disabled = resolve(field.disabled, context);
  const disabledHint = resolve(field.disabledHint, context);

  if (field.type === "CHECKBOX") {
    return (
      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          name={field.key}
          checked={!!value}
          onChange={onChange}
          disabled={disabled}
        />
        <label className="text-sm">{field.label}</label>
      </div>
    );
  }

  if (field.type === "INPUT_OTP") {
    return (
      <InputWithOTPV2
        field={field}
        value={value}
        onChange={onChange}
        error={error}
        disabled={disabled}
        disabledHint={disabledHint}
        otpState={context.otpState}
        setOtpState={context.setOtpState}
        otpHandlers={context.otpHandlers}
      />
    );
  }

  return (
    <InputFieldV2
      field={field}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      disabledHint={disabledHint}
    />
  );
});

export default AddressField;
